module.exports = __webpack_public_path__ + "static/media/vegitables_2.126c4c26.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_2.csv
// module id = 602
// module chunks = 0